import React from 'react';
import { Alert } from 'reactstrap';

const Introduction: React.FC = () => {
  return (
    <div className="p-3">
      <h5 className="mb-3">Welcome to the Support at Home Statement Generator</h5>

      <p className="mb-3">
        <strong>Support at Home statements are fundamentally different from Home Care Package statements.</strong>
        <br />
        This process is not the same and involves complex calculations.
      </p>

      <p className="mb-3">
        <strong>Once a statement has been generated:</strong>
      </p>
      <ul className="mb-3">
        <li>Information cannot be edited</li>
        <li>Statements cannot be deleted</li>
        <li>All data is sourced directly from claims and reconciliations</li>
      </ul>

      <p className="mb-3">
        For statements to be compliant and up to date, all claim items must be generated and fully reconciled in
        TurnPoint before proceeding.
      </p>

      <Alert color="danger" className="mb-3">
        <strong>DO NOT PROCEED</strong> unless you have read and fully understood the process outlined in our Knowledge
        Base:
        <br />
        <a
          href="https://turnpoint.zendesk.com/hc/en-us/articles/14592780603151-SAH-Creating-Statements"
          target="_blank"
          rel="noopener noreferrer"
          className="alert-link"
        >
          https://turnpoint.zendesk.com/hc/en-us/articles/14592780603151-SAH-Creating-Statements
        </a>
      </Alert>

      <p className="mb-3">
        <strong className="text-danger">
          If you proceed after ignoring instructions or making an error, TurnPoint Support may not be able to assist.
        </strong>
      </p>

      <Alert color="info" className="mb-0">
        <p className="mb-2">
          <strong>There is no preview option.</strong>
        </p>
        <p className="mb-2">
          Once a statement is created, it is finalised due to the complex calculations required to maintain accurate
          balances.
        </p>
        <p className="mb-0">
          <strong>Only proceed if you are ready to generate and issue statements.</strong>
        </p>
      </Alert>
    </div>
  );
};

export default Introduction;
